import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { typeName } from '../../fieldOptions/postTypes'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Type', prop: 'type', format: typeName },
  { title: 'URL', prop: 'slug' },
  { title: 'Publish Date', prop: 'publish_date', format: 'dateWithTime' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'title', direction: 'asc' }]
}

const Posts = props => (
  <List
    title='Posts'
    apiPath='admin/posts'
    columns={columns}
    defaults={defaults}
    filters={filters}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Posts
